// ============================== Định nghĩa các value để phục vụ cho việc log ==============================

export const PARENT_TYPE = {
  restaurant: 'Restaurant',
  hotel: 'Hotel',
  souvenir: 'Souvenir',
  food_court: 'Food court',
}

export const FOOD_COURT_TYPE = 'food_court'

// Định nghĩa các hành động của User
export const USER_ACTIONS = {
  scan_qrcode: 'Scan QRcode',
  impression: 'Impression',
  click: 'Click',
}

export const CHILD_TYPE = {
  restaurant: 'Restaurant',
  menu: 'Menu',
}

export const USER_ACTIONS_ID = {
  scan_qrcode: 0,
  click: 1,
}
